import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { HasStockObjectPipe } from '../../helpers';
import { BufferstockListComponent } from './bufferstock-list.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
  ],
  declarations: [BufferstockListComponent, HasStockObjectPipe],
  exports: [BufferstockListComponent],
  entryComponents: [BufferstockListComponent],
})
export class BufferstockListComponentModule {}
